<div
  class="relative flex h-full flex-col items-center justify-center gap-1 overflow-hidden"
  [ngClass]="{
    'cursor-pointer border-2 border-background-white bg-background-white hover:border-background-light-blue hover:bg-background-light-blue':
      isClickable,
    '!border-primary-blue !bg-background-light-blue': isSelected()
  }"
  [class]="roundedClasses"
  (click)="onArchClicked($event)"
>
  @if (arch() === 'maxillary' && isClickable) {
    <div class="typo-h4-thin absolute top-0 pt-4 text-text-primary">{{ 'charting_add_treatment_arch_maxillary_label' | translate }}</div>
  }
  <div class="flex h-full w-full justify-center gap-1">
    <lib-quadrant-cell
      class="flex-1"
      [teeth]="teeth()"
      [selectedTeethPositions]="selectedTeethPositions()"
      [drawTreatments]="drawTreatments()"
      [quadrant]="leftQuadrant()"
      [showBackground]="showQuadrantBackground"
      [paddingClass]="paddingClass"
      [isClickable]="isQuadrantClickable"
      [isSelected]="selectedQuadrant().includes(leftQuadrant())"
      [showLabel]="isQuadrantClickable"
      (clicked)="onToothClicked($event)"
      (quadrantClicked)="onQuadrantClicked($event)"
    />
    <lib-quadrant-cell
      class="flex-1"
      [teeth]="teeth()"
      [selectedTeethPositions]="selectedTeethPositions()"
      [drawTreatments]="drawTreatments()"
      [quadrant]="rightQuadrant()"
      [showBackground]="showQuadrantBackground"
      [paddingClass]="paddingClass"
      [isClickable]="isQuadrantClickable"
      [isSelected]="selectedQuadrant().includes(rightQuadrant())"
      [showLabel]="isQuadrantClickable"
      (clicked)="onToothClicked($event)"
      (quadrantClicked)="onQuadrantClicked($event)"
    />
  </div>
  @if (arch() === 'mandibular' && isClickable) {
    <div class="typo-h4-thin absolute bottom-0 pb-4 text-text-primary">
      {{ 'charting_add_treatment_arch_mandibular_label' | translate }}
    </div>
  }
</div>
